import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "../components/layout/AppShell";
import LoginPage from "../features/auth/LoginPage";
import IndividualListPage from "../features/individual/IndividualListPage";
import IndividualDetailPage from "../features/individual/IndividualDetailPage";
import TeamListPage from "../features/teams/TeamListPage";
import TeamSessionsPage from "../features/teams/TeamSessionsPage";
import TeamSessionDetailPage from "../features/teams/TeamSessionDetailPage";
import TeamSessionNotesPage from "../features/teams/TeamSessionNotesPage";
import TeamEditPage from "../features/teams/TeamEditPage";

const RoutesView = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AppShell />}>
        <Route path="/individual" element={<IndividualListPage />} />
        <Route path="/individual/:publicId" element={<IndividualDetailPage />} />
        <Route path="/teams" element={<TeamListPage />} />
        <Route path="/teams/:teamId/sessions" element={<TeamSessionsPage />} />
        <Route
          path="/teams/:teamId/sessions/:sessionId"
          element={<TeamSessionDetailPage />}
        />
        <Route
          path="/teams/:teamId/sessions/:sessionId/notes"
          element={<TeamSessionNotesPage />}
        />
        <Route path="/teams/:teamId/edit" element={<TeamEditPage />} />
      </Route>
    </Routes>
  );
};

export default RoutesView;
